const PANEL_PREFIXES = ['/dashboard', '/admin', '/support'] as const
const MIN_VISIBLE_MS = 280

function isPanelPath(path: string) {
  return PANEL_PREFIXES.some(prefix => path === prefix || path.startsWith(`${prefix}/`))
}

export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()
  const isLoading = useState('panel-route-loading', () => false)

  let shownAt = 0
  let hideTimer: ReturnType<typeof setTimeout> | undefined
  let panelNavigation = false

  const clearHideTimer = () => {
    if (hideTimer !== undefined) {
      clearTimeout(hideTimer)
      hideTimer = undefined
    }
  }

  const hideLoading = () => {
    clearHideTimer()
    const elapsed = Date.now() - shownAt
    const remaining = Math.max(0, MIN_VISIBLE_MS - elapsed)
    hideTimer = setTimeout(() => {
      isLoading.value = false
      panelNavigation = false
      hideTimer = undefined
    }, remaining)
  }

  const resetLoading = () => {
    clearHideTimer()
    panelNavigation = false
    isLoading.value = false
  }

  router.beforeEach((to, from) => {
    if (to.fullPath === from.fullPath) return
    if (from.matched.length === 0) return
    panelNavigation = isPanelPath(to.path) || isPanelPath(from.path)
    if (!panelNavigation) return

    clearHideTimer()
    shownAt = Date.now()
    isLoading.value = true
  })

  // Hide only after the new page Suspense resolves — not on router.afterEach.
  nuxtApp.hook('page:loading:end', () => {
    if (!panelNavigation && !isLoading.value) return
    hideLoading()
  })

  nuxtApp.hook('vue:error', resetLoading)
  router.onError(resetLoading)
})
